<template>
  <div 
    class="expanded expanded--columns" 
    :class="expand ? 'active' : ''"    
  >
    <div class="train__info uk-margin-bottom">
      <div class="train__item" uk-tooltip="Шаг">
        <div v-show="!multiplayer" class="train__ico train__ico--1"></div>
        <small>Шаг:</small>
        {{ step }}
      </div>
      <div class="train__item" uk-tooltip="Ошибок сделано">
        <div v-show="!multiplayer" class="train__ico train__ico--2"></div>
        <small>Ошибок:</small>
        {{ errors }}
      </div>
      <div
        class="train__item"
        v-if="$route.params.isHomework"
        uk-tooltip="Выполнено"
      >
        <div v-show="!multiplayer" class="train__ico train__ico--4"></div>
        <small>Выполнено:</small>
        {{ $route.params.total }} из {{ $route.params.qnt }}
      </div>
      <div class="train__item train__item--time" uk-tooltip="Времени прошло">
        <div v-show="!multiplayer" class="train__ico train__ico--3"></div>
        <span
          ><small>Времени прошло:</small> {{ timer.minutes }}:{{
            timer.seconds
          }}</span
        >
      </div>
    </div>

    <div
      class="columns"
      v-show="!reaction"
      :class="'columns-' + inkey"
      :style="params.users > 1 ? 'border-color:' + colors[inkey] : ''"
    >
      <div class="game_set">
        <div
          v-if="role === 'teacher'"
          class="game__settings"
          @click="setShowsettings"
        ></div>
        <local_setting
          v-if="role === 'teacher'"
          :params="params"
          @params_changed="params_changed"
        ></local_setting>
      </div>
      <div
        class="game__name"
        v-if="role === 'teacher'"
        :class="users > 5 ? 'game__name--wrap' : ''"
      >
        Игрок {{ inkey }}
      </div>
      
      <div
        class="columns__cifs"
        :class="'columns__cifs-' + inkey"
        v-if="currentStep == 'answer'"
      >
        <div 
          v-for="cif in cifers" 
          :key="cif.id"
          :style="`flex-basis: ${100 / cifers.length}%`"
        >
          {{ cif }}
        </div>
      </div>
      <div v-if="is_error" class="flash__message flash__error">
        {{ users < 5 ? "Неправильно!" : "Нет!" }}
      </div>
      <div v-if="is_success" class="flash__message flash__success">
        {{ users < 5 ? "Правильно!" : "Да!" }}
      </div>
      <div
        v-if="!result"
        class="columns__ok"
        :class="users > 1 ? 'columns__ok--wrap' : ''"
      >
        <input
          type="tel"
          :id="'game_input-' + inkey"
          class="game_input uk-input"
          autocomplete="off"
          @keyup.enter="checkAnswer2"
          v-model="userNumber"
          :placeholder="users > 4 ? 'Ответ' : 'Введите ответ'"
        />
        <button 
          class="uk-button uk-button-primary" 
          @click="checkAnswer" 
        >
          {{ users > 4 ? "Ок" : "Ответ" }}
        </button>
      </div>
      <div class="repeat" v-if="result">        
        <p class="cifers">
          <span>{{ cifersString }} </span>
          <span> = </span>
          <span class="scores"><strong>{{ sum }}</strong></span>
        </p>
        <p>
          <strong>Результат:</strong><br />
          Ваш ответ: {{ userNumber }}
          <span
            class="mental__checks"
            :class="+userNumber === sum ? '' : 'active'"
          ></span>
        </p>
        <p class="scores">
          Баллы: <strong>{{ scores }}</strong>
        </p>
        <button
          :id="'repeat-' + inkey"
          class="repeat-btn uk-button uk-button-primary"
          @click="reset"
          v-if="!checkHomeworkFinish()"
        >
          Дальше!
        </button>

        <button
          class="uk-button uk-button-primary"
          @click="onStopTrainer"
          v-else
        >
          Закончить
        </button>
      </div>
    </div>

    <div class="modsettings" v-if="showsettings">
      <div class="modsettings__back" @click="setShowsettings"></div>
      <div class="modsettings__body">
        <h2>Настройки тренажера Игрока {{ inkey }}</h2>
        <div class="instructions">
          <settings
            :inparams="params"
            @params_changed="params_changed"
          ></settings>
        </div>
        <div class="modsettings__button">
          <button class="uk-button uk-button-primary" @click="setShowsettings">
            Применить
          </button>
        </div>
      </div>
    </div>

    <div class="wh-block wh-block--reaction" v-if="reaction">
      <div class="reaction">
        <!--<video loop muted preload="auto" autoplay>-->
        <video
          disableRemotePlayback
          preload="auto"
          autoplay
          @ended="stopReaction"
        >
          <source
            type="video/mp4"
            :src="'/storage/app/media/reactions/' + reaction_file"
            id="mp4"
          />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { mix } from "../mixin";
import { mental_mix } from "../mental/mental_mixin";
//import { mental_params_mix } from "../mental/mental_params_mixin";
import local_setting from "./local_setting";
import Select2 from "v-select2-component";
import settings from "./components/Settings";
import axios from "axios";
import swal from "sweetalert";

export default {
  name: "game",
  components: { Select2, settings, local_setting },
  mixins: [mix, mental_mix],
  props: {
    inkey: "",
    multiplayer: {
      default: false,
    },
  },
  data() {
    return {
      expand: false,
      reaction: false,
      reaction_file: "",
      active: false,
      /** Шаги в случае ряда примеров */
      step: 1,
      /** Ошибок */
      errors: 0,
      /** Массив сгенерированных чисел */
      cifers: "",
      /** Сумма */
      sum: "",
      /** Ответ пользователя */
      userNumber: "",
      /** Цифры обратного отсчета */
      countDownCifs: 3,
      /** Точки - показ количества слагаемых */
      dots: 0,
      odd_even: "odd",
      /** Текущая цифра */
      currentCif: "",
      /** Текущий шаг */
      currentStep: "",
      /** В случае ошибки */
      is_error: false,
      /** В случае успеха */
      is_success: false,
      result: false,
      showsettings: false,
      params: "",
      results: [],
      local_result: [],
      stat_id: "",
      scores: 0,
    };
  },
  watch: {
    users: "checkFz",
  },
  computed: {
    /*...mapState({
      params: state => state.train.columns_params
    }),*/
    users() {
      return this.$store.state.train.columns_params.users;
    },
    user() {
      return this.$store.state.user;
    },
    role() {
      return this.user.role.code;
    },
    colors() {
      return this.$store.state.colors;
    },
    cifersString() {
      let string = ''
      if (this.cifers) {
        this.cifers.forEach((item, i) => {
          if (i > 0 && item >= 0) {
            string += "+" + item
          } else if (item < 0 || i === 0) {
            string += "" + item
          }
        })
      }      
      return string      
    }
  },
  methods: {
    /**
     * ФУНКЦИИ ИГРЫ
     * */

    /** Начать игру */
    startGame() {
      this.scroll();
      this.finish = false;
      this.result = false;
      this.userNumber = "";
      this.local_result = [];
      this.step++;
      this.dots = 0;
      this.currentStep = "answer";
      this.startTimer();
      setTimeout(() => {
        this.checkFz()
      }, 50) 
      if ($(window).width() > 720) {
        setTimeout(function () {
          if (app.users === 1) {
            $('#game_input-' + app.inkey).focus();
          } else {
            $('#game_input-1').focus();
          }
        }, 200);
      }
    },

    /** Вычисляем размер шрифта */
    checkFz() {
      console.log('fz')
      const elems = document.querySelectorAll(`.columns__cifs-${this.inkey} div`)
      elems.forEach(el => {
        el.style.flexBasis = 100 / elems.length + '%'

        let height = el.clientHeight
        el.style.fontSize = height / 1.5 + 'px'
      })
    },
    /** Проверяем ответ */
    checkAnswer2() {
      if (this.users > 1) {
        this.$root.$emit("fullCheck");
      } else {
        this.checkAnswer();
      }
    },
    checkAnswer() {
      if (!this.finish && this.userNumber && !this.result) {
        this.finish = true;
        this.checkError();
        this.$emit("localChanged");
        let app = this;
        setTimeout(function () {
          app.result = true;
                    
        }, 1000);
        let result = {
          timer: this.timer,
          step: this.step,
          cifers: this.cifers,
          sum: this.sum,
          user_answer: +this.userNumber,
        };
        this.results.push(result);
        this.local_result.push(result);
        this.addScores();
        if (this.step > 1 && this.stat_id) {
          this.updateStats();
        } else {
          this.makeStats();
        }
        this.startReaction();        
      }
    },
    /** Устанавливаем статус результата */
    setStatus(val) {
      let app = this;
      this[val] = true;
      setTimeout(function () {
        app[val] = false;
      }, 1000);
    },
    /** Проверяем есть ли ошибки */
    checkError() {
      this.userNumber = Number(this.userNumber.replace(/\D+/g, ""));
      if (this.sum == this.userNumber) {
        this.setStatus("is_success");
        //this.result = this.currentNumber + " = "+ this.userNumber;
      } else {
        this.setStatus("is_error");
        //this.result = this.currentNumber + " <span class='fn'>≠</span> "+ this.userNumber;
        this.errors++;
      }
    },

    fullReset() {
      console.log("FullReset");
      if (this.checkFinishHomework()) {
        this.onStopTrainer();
      } else {
        if (this.user.role === "teacher" && this.users > 1) {
          console.log("FullReset");
          this.step = 0;
          this.errors = 0;
          this.nextNum = "";
          this.stat_id = "";
          this.finish = true;
          let app = this;
          setTimeout(function () {
            app.generatorBase();
            app.startGame();
          }, 1000);
        } else {
          this.reset();
        }
      }
    },

    /** Сбрасываем значения */
    reset() {
      this.nextNum = "";
      this.finish = true;
      this.timer = {};
      this.generatorBase();
      this.startGame();      
    },
    /** Останавливаем игру */
    stopGame() {
      this.active = false;
    },

    /**
     *
     * ЗДЕСЬ СТАРТ ПРИЛОЖЕНИЯ
     *
     * */

    startApp() {
      if (this.params.terms > 25) {
        this.params.terms = 25;
      }
      //this.startGame();
      this.currentStep = "answer";
      this.stopGame();
      setTimeout(() => {
        this.checkFz()
      }, 50) 
    },

    params_changed(val) {
      console.log("Params changed");
      this.params = val;
      this.reset()           
    },
    setShowsettings() {
      this.showsettings = !this.showsettings;
      if (this.showsettings) {
        $(document.body).addClass("fixed");
      } else {
        $(document.body).removeClass("fixed");
      }
    },
    startReaction() {
      if (this.users === 1 && this.params.show_reactions) {
        let type = this.sum == this.userNumber ? "react_plus" : "react_minus";
        this.reaction_file = this.checkReaction(type);
        this.reaction = true;
        setTimeout(function () {
          UIkit.scroll(".headline2").scrollTo(".wh-block--reaction");
        }, 100);
      }
    },
    stopReaction() {
      this.reaction = false;
      let app = this;
      setTimeout(function () {
        app.scroll();
        //$('#repeat-' + app.inkey).focus();
      }, 100);
    },
    scroll() {
      UIkit.scroll(".headline2", {
        offset: 60,
      }).scrollTo(".game__body");
    },
    addScores() {
      //console.log('Add scores');
      let sum = 0;
      let result = this.local_result;
      let from = this.minAxis;
      let to = this.maxAxis;
      let cif;
      let terms = this.params.terms;
      if (from === to) {
        cif = to;
      } else {
        cif = to - 0.5;
      }

      result.forEach(function (e) {
        console.log(e);
        if (e.sum === e.user_answer) {
          sum = sum + terms * (cif * cif);
        } else {
          console.log("Ошибки не считаем");
        }
      });
      sum = Math.ceil(sum);

      if (this.$route.params.isHomework) {
        sum = Math.ceil(sum * this.$store.state.hw_coefficient);
      }

      this.checkScoreStatus(sum);

      this.scores = sum;
      this.$store.commit("changeUserScores", sum);
      console.log("Баллов заработано", sum);
    },
    makeStats() {
      if (this.user.role.code === "student") {
        let path = this.$route.params.is_matrius ? 'onSaveMatriusAnswer' : 'onSaveStats'
        console.log("Бережно сохраняем статистику");
        let app = this;
        let time = this.timer;
        let errors = this.errors;
        let train_params = this.params;
        let stats = {
          //time: time,
          errors: errors,
          user_id: this.$store.state.user.id,
          trainer: this.$store.state.current_trainer.id,
          count: this.step,
          results: this.results,
          total: this.getTotalTime(this.results),
          scores: this.scores,
          train_params: {
            formula: train_params.formula,
            rank: train_params.rank,
            terms: train_params.terms,
            cifers: train_params.cifers,
            cifers_dop: train_params.cifers_dop,
          },
        };
        stats = this.checkHomework(stats);

        if (this.$route.params.is_matrius) {
          stats.student_task_id = this.$route.params.student_task_id
          stats.qnt = this.$route.params.qnt
        }

        let data = {
          'stat': stats
        }
        this.http.post(path, data).then((res) => {
          this.stat_id = res.data.id;
          this.checkCoins(res.data);

          if (this.$route.params.is_matrius && res.data.is_done) {
            swal('Успешно!', res.data.message, 'success')
          }
        })
        .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
      } else {
        console.log("Учителей в статистику не заносим! Понятно?!");
      }
    },
    updateStats() {
      if (this.user.role.code === "student") {
        console.log("Update stats");
        let results = this.results;
        let time = this.getTotalTime(results);
        let stat_id = this.stat_id;
        let arr = {
          result: results,
          time: time,
          errors: this.errors,
          stat_id: stat_id,
          count: this.step,
          scores: this.scores,
          isHomework: this.$route.params.isHomework ? true : false,
        };
        //console.log(arr);

        this.updateHomework();

        axios
          .post(
            window.location.href,
            { stat: arr },
            {
              headers: {
                "X-OCTOBER-REQUEST-HANDLER": "onUpdateStats",
                "X-Requested-With": "XMLHttpRequest",
              },
            }
          )
          .then((res) => {
            this.checkCoins(res.data);
            //console.log(res);
          });
      }
    },
    getTotalTime(arr) {
      return _.reduce(
        arr,
        function (sum, i) {
          return sum + i.timer.total_ms;
        },
        0
      );
    },
  },
  mounted() {
    let app = this;
    window.onresize = function (event) {
      app.checkFz();
    };
    this.$root.$on("fullCheck", this.checkAnswer);
    this.$root.$on("fullStart", this.fullReset);
    this.params = _.cloneDeep(this.$store.state.train.columns_params);
    this.generatorBase();
    this.startApp();
  },
  beforeDestroy() {
    this.$root.$off("fullCheck", this.checkAnswer);
    this.$root.$off("fullStart", this.fullReset);
    if (this.users === 1) {
      this.$parent.commitVal(false, "start");
    }
  }
};
</script>

<style lang="scss" scoped>
.train__info {
  flex-wrap: wrap;
}

.train__item--time span {
  width: 60px;
  text-align: center;
}
.repeat {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  padding: 20px 10px;
  background-color: #fff;
  box-shadow: 0 2px 10px 0 #666666;
}

.cifers {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: bold;

  & span {
    margin-right: 5px;
  }
}
.repeat-btn {
  padding: 10px;
}
</style>